import { withInstall } from '@zoryn/utils'
import Result from './src/result.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZResult: SFCWithInstall<typeof Result> = withInstall(Result)

export default ZResult

export * from './src/result'
